import { useAuth } from "@assetwatch/auth";
import { InlineLink, Stack, Text, Title } from "@assetwatch/ui";
import { Card } from "@assetwatch/ui/experimental";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { isInternalEnterpriseUser } from "../lib/enterpriseAccess";

export function EnterpriseCustomerSelectionCard({
  title,
  description,
}: {
  title?: string;
  description?: string;
}) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isInternalUser = isInternalEnterpriseUser(user);
  const resolvedTitle = title ?? t("enterprise.common.selectCustomerTitle");
  const resolvedDescription =
    description ??
    (isInternalUser
      ? t("enterprise.chrome.customerState.internalSelectionDescription")
      : t("enterprise.chrome.customerState.externalSelectionDescription"));

  return (
    <Card data-testid="customer-selection-card">
      <Stack gap={8}>
        <Title>{resolvedTitle}</Title>
        <Text size="sm" tone="subtle">
          {resolvedDescription}
        </Text>
      </Stack>
    </Card>
  );
}

export function EnterpriseCustomerAccessCard() {
  const { t } = useTranslation();

  return (
    <Card data-testid="customer-access-error-card">
      <Stack gap={12}>
        <div>
          <Title>{t("enterprise.chrome.customerState.accessErrorTitle")}</Title>
          <Text size="sm" tone="subtle">
            {t("enterprise.chrome.customerState.accessErrorDescription")}
          </Text>
        </div>

        <InlineLink render={<Link to="/" />}>
          {t("enterprise.chrome.customerState.returnToCustomerSelection")}
        </InlineLink>
      </Stack>
    </Card>
  );
}
